  (() => {
    const initStoneBuilder = (root) => {
      if (!root || root.dataset.stoneBuilderReady === 'true') return;
      root.dataset.stoneBuilderReady = 'true';

    const configEl = root.querySelector('[data-stone-builder-config]');
    const beadsEl = root.querySelector('[data-stone-builder-beads]');
    const canvas = root.querySelector('[data-stone-builder-canvas]');
    const hitLayer = root.querySelector('[data-stone-builder-hit-layer]');
    const emptyState = root.querySelector('[data-stone-builder-empty]');
    const totalEl = root.querySelector('[data-stone-builder-total]');
    const countEl = root.querySelector('[data-stone-builder-count]');
    const wristEl = root.querySelector('[data-stone-builder-wrist]');
    const statusEl = root.querySelector('[data-stone-builder-status]');
    const diameterGroup = root.querySelector('[data-stone-builder-diameter-group]');
    const categoriesEl = root.querySelector('[data-stone-builder-categories]');
    const gridEl = root.querySelector('[data-stone-builder-grid]');
    const removeButton = root.querySelector('[data-stone-builder-remove]');
    const undoButton = root.querySelector('[data-stone-builder-undo]');
    const submitButton = root.querySelector('[data-stone-builder-submit]');
    const designsOpenButton = root.querySelector('[data-stone-builder-designs-open]');
    const designsCountEl = root.querySelector('[data-stone-builder-designs-count]');
    const soundToggleButton = root.querySelector('[data-stone-builder-sound-toggle]');
    const designSaveButton = root.querySelector('[data-stone-builder-save]');
    const designsModal = root.querySelector('[data-stone-builder-designs-modal]');
    const designsDialog = root.querySelector('.stone-builder__designs-dialog');
    const designsCloseButton = root.querySelector('[data-stone-builder-designs-close]');
    const designsList = root.querySelector('[data-stone-builder-designs-list]');
    const designsMessage = root.querySelector('[data-stone-builder-designs-message]');
    const designCopyButton = root.querySelector('[data-stone-builder-design-copy]');
    const designNewButton = root.querySelector('[data-stone-builder-design-new]');
    const switchModal = root.querySelector('[data-stone-builder-switch-modal]');
    const switchKeepButton = root.querySelector('[data-stone-builder-switch-keep]');
    const switchLoadButton = root.querySelector('[data-stone-builder-switch-load]');
    const sizeGuideOpenButton = root.querySelector('[data-stone-builder-size-guide-open]');
    const sizeGuideModal = root.querySelector('[data-stone-builder-size-guide-modal]');
    const sizeGuideCloseButton = root.querySelector('[data-stone-builder-size-guide-close]');
    const sizeGuideTabs = Array.from(root.querySelectorAll('[data-stone-builder-size-guide-tab]'));
    const sizeGuidePanels = Array.from(root.querySelectorAll('[data-stone-builder-size-guide-panel]'));
    const modal = root.querySelector('[data-stone-builder-modal]');
    const modalMessage = root.querySelector('[data-stone-builder-modal-message]');
    const modalCloseButton = root.querySelector('[data-stone-builder-modal-close]');
    const ctx = canvas.getContext('2d');
    const accentColor = getComputedStyle(root).getPropertyValue('--stone-accent').trim() || '#be6a57';
    const previewUploadEndpoint = 'https://crystallabs-preview-upload.ssimonphu.workers.dev/upload';
    const previewBaseUrl = 'https://crystallabs-preview-upload.ssimonphu.workers.dev/preview/';
    const previewUploadSize = 500;
    const previewUploadQuality = 0.76;
    const previewCaptureSize = 1200;
    const previewCaptureQuality = 0.92;
    const previewCaptureStoragePrefix = 'scb-preview-capture:';
    const savedDesignStorageKey = 'stone-canvas-builder:designs:v1';
    const soundStorageKey = 'stone-canvas-builder:sound:v1';
    const MAX_SAVED_DESIGNS = 3;

    let config = { baseItem: null, minimumBeads: 9, currencyCode: 'USD' };
    let beadLibrary = [];
    let selectedBeads = [];
    let selectedIndex = 0;
    let selectedLibraryId = null;
    let activeCategory = 'All';
    let activeDiameter = 8;
    let history = [];
    let hitRegions = [];
    let hitTargetSignature = '';
    let imageCache = new Map();
    let pendingFrame = null;
    let beadMotion = null;
    let layoutMotion = null;
    let dragState = null;
    let suppressNextCanvasClick = false;
    let beadInstanceSeq = 0;
    let statusOverride = '';
    let sizeGuidePreviousBodyOverflow = '';
    let savedDesigns = [];
    let savedDraft = null;
    let activeDesignSlot = null;
    let activeDesignSignature = '';
    let pendingDesignSlot = null;
    let designModalPreviousBodyOverflow = '';
    let designModalPreviousFocus = null;
    let designSaveNoticeTimer = null;
    let statusOverrideTimer = null;
    let storageAvailable = true;
    let lastPersistedDraftSignature = '';
    let soundEnabled = false;
    let soundContext = null;
    let lastMoveSoundTarget = null;
    let lastMoveSoundAt = 0;

    const parseJson = (node, fallback) => {
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return fallback;
      }
    };

    config = parseJson(configEl, config);
    const parseDiameterOptions = (value) => {
      const source = Array.isArray(value) ? value : String(value || '').split(',');
      const sizes = source
        .map((item) => Number(String(item).trim().replace(/mm$/i, '')))
        .filter((size) => Number.isFinite(size) && size > 0);

      return Array.from(new Set(sizes));
    };
    const configuredDiameters = parseDiameterOptions(config.beadSizeOptions);
    const supportedDiameters = configuredDiameters.length ? configuredDiameters : [8, 10];
    const configuredDefaultDiameter = Number(config.defaultBeadSize || supportedDiameters[0]);
    activeDiameter = supportedDiameters.includes(configuredDefaultDiameter)
      ? configuredDefaultDiameter
      : supportedDiameters[0];
    const correctionTable = [
      { size: 6, correction: 2.0 },
      { size: 8, correction: 2.3 },
      { size: 10, correction: 2.4 },
      { size: 12, correction: 2.8 },
      { size: 14, correction: 2.6 },
      { size: 16, correction: 2.7 },
      { size: 18, correction: 2.8 }
    ];
    const MAX_FIT_WRIST_CM = 26;
    const diameterLabel = (size = activeDiameter) => `${size}mm`;
    const supportedDiameterLabels = supportedDiameters.map((size) => `${size}mm`);

    const normalizeSizeToken = (value) => {
      if (value === null || value === undefined) return '';
      const normalized = String(value).trim().toLowerCase().replace(/\s+/g, '');
      const match = normalized.match(/(\d+(?:\.\d+)?)mm/);
      if (match) return `${Number(match[1])}mm`;
      if (supportedDiameters.includes(Number(normalized))) return `${Number(normalized)}mm`;
      return normalized;
    };

    const normalizeVariant = (variant) => {
      const candidateValues = [variant.option1, variant.option2, variant.option3, variant.title];
      const size = candidateValues.map(normalizeSizeToken).find((value) => supportedDiameterLabels.includes(value)) || '';
      return { ...variant, available: variant.available !== false, size };
    };
    const isFixedSizeCharm = (bead) => bead && bead.type === 'fixed_charm';
    const fixedDiameterForBead = (bead, fallback = activeDiameter) => {
      const diameter = Number(bead && bead.fixedDiameter);
      return Number.isFinite(diameter) && diameter > 0 ? diameter : fallback;
    };

    const normalizeCategories = (bead) => {
      const source = Array.isArray(bead.categories) ? bead.categories : [bead.category];
      const categories = source
        .map((category) => String(category || '').trim())
        .filter(Boolean);

      return categories.length ? Array.from(new Set(categories)) : ['Uncategorized'];
    };

    beadLibrary = parseJson(beadsEl, [])
      .filter((bead) => bead.name)
      .map((bead) => ({
        ...bead,
        categories: normalizeCategories(bead),
        variants: Array.isArray(bead.variants) ? bead.variants.map(normalizeVariant) : []
      }))
      .filter((bead) => bead.variants.length > 0);
    if (beadLibrary.length) selectedLibraryId = beadLibrary[0].id;

    const currencyCode = config.currencyCode || 'USD';
    const formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'narrowSymbol'
    });

    const currentLibraryStyle = () => beadLibrary.find((bead) => bead.id === selectedLibraryId) || beadLibrary[0] || null;
    const beadVariantForDiameter = (bead, size = activeDiameter) => {
      if (!bead || !Array.isArray(bead.variants)) return null;
      if (isFixedSizeCharm(bead)) return bead.variants.find((variant) => variant.available !== false) || null;
      return bead.variants.find((variant) => variant.size === `${size}mm` && variant.available !== false) || null;
    };
    const resolvedBeadForDiameter = (bead, size = activeDiameter) => {
      const variant = beadVariantForDiameter(bead, size);
      if (!variant) return null;
      const resolvedDiameter = isFixedSizeCharm(bead) ? fixedDiameterForBead(bead, size) : size;
      return {
        id: bead.id,
        productId: bead.productId,
        name: bead.name,
        categories: bead.categories,
        image: bead.image || '',
        variantId: variant.id,
        priceCents: Number(variant.priceCents || 0),
        sku: variant.sku || '',
        diameter: resolvedDiameter
      };
    };
    const totalCents = (beads = selectedBeads) => {
      const base = Number(config.baseItem && config.baseItem.priceCents ? config.baseItem.priceCents : 0);
      return base + beads.reduce((sum, bead) => sum + Number(bead.priceCents || 0), 0);
    };
    const formatCm = (value) => Number(value || 0).toFixed(1);
    const cmToInches = (value) => Number(value || 0) / 2.54;
    const formatInches = (value) => cmToInches(value).toFixed(1);
    const formatMeasurement = (value) => `${formatInches(value)} in / ${formatCm(value)} cm`;
    const formatFitSize = (value) => `${formatInches(value)} in / ${formatCm(value)} cm`;
    const interpolateCorrection = (averageDiameter) => {
      if (averageDiameter <= correctionTable[0].size) return correctionTable[0].correction;
      if (averageDiameter >= correctionTable[correctionTable.length - 1].size) return correctionTable[correctionTable.length - 1].correction;

      for (let index = 0; index < correctionTable.length - 1; index += 1) {
        const current = correctionTable[index];
        const next = correctionTable[index + 1];
        if (averageDiameter >= current.size && averageDiameter <= next.size) {
          const progress = (averageDiameter - current.size) / (next.size - current.size);
          return current.correction + (next.correction - current.correction) * progress;
        }
      }

      return correctionTable[correctionTable.length - 1].correction;
    };
    const braceletMetrics = (beads = selectedBeads) => {
      const totalDiameterMm = beads.reduce((sum, bead) => sum + Number(bead.diameter || activeDiameter), 0);
      const averageDiameter = beads.length ? totalDiameterMm / beads.length : activeDiameter;
      const braceletLengthCm = totalDiameterMm / 10;
      const sizeCorrectionCm = interpolateCorrection(averageDiameter);
      const fitWristCm = Math.max(0, braceletLengthCm - sizeCorrectionCm);
      return {
        averageDiameter,
        braceletLengthCm,
        fitWristCm,
        sizeCorrectionCm,
        totalDiameterMm
      };
    };
    const wristSize = () => formatCm(braceletMetrics().fitWristCm);
    const braceletLength = () => formatCm(braceletMetrics().braceletLengthCm);
    const maxFitMessage = () => `This bracelet has reached the maximum estimated fit of ${formatFitSize(MAX_FIT_WRIST_CM)}. Remove a bead or choose a smaller size to continue.`;
    const sizeSummary = () => {
      if (!selectedBeads.length) return diameterLabel();
      const counts = new Map();
      selectedBeads.forEach((bead) => {
        const size = Number(bead.diameter || activeDiameter);
        counts.set(size, (counts.get(size) || 0) + 1);
      });
      return supportedDiameters
        .filter((size) => counts.has(size))
        .map((size) => `${diameterLabel(size)} x${counts.get(size)}`)
        .join(' / ');
    };
    const formatMoney = (cents) => formatter.format(Number(cents || 0) / 100);
    const formatMoneyWithCurrency = (cents) => `${formatMoney(cents)} ${currencyCode}`;
    const categoryList = () => ['All', ...Array.from(new Set(beadLibrary.flatMap((bead) => bead.categories)))];

    const soundPattern = (type) => {
      const patterns = {
        tap: [{ frequency: 520, duration: 0.032, gain: 0.018, type: 'sine' }],
        add: [{ frequency: 660, duration: 0.055, gain: 0.024, type: 'sine' }],
        pick: [{ frequency: 420, duration: 0.045, gain: 0.018, type: 'triangle' }],
        move: [{ frequency: 560, duration: 0.028, gain: 0.012, type: 'sine' }],
        place: [{ frequency: 720, duration: 0.05, gain: 0.02, type: 'triangle' }],
        remove: [{ frequency: 260, duration: 0.075, gain: 0.018, type: 'sine' }],
        saved: [
          { frequency: 620, duration: 0.055, gain: 0.018, type: 'sine' },
          { frequency: 820, delay: 0.045, duration: 0.07, gain: 0.016, type: 'sine' }
        ]
      };
      return patterns[type] || patterns.tap;
    };
    const updateSoundToggle = () => {
      if (!soundToggleButton) return;
      soundToggleButton.setAttribute('aria-pressed', soundEnabled ? 'true' : 'false');
      soundToggleButton.textContent = soundEnabled ? 'Sound on' : 'Sound off';
      soundToggleButton.title = soundEnabled ? 'Sound on' : 'Sound off';
    };
    const readSoundPreference = () => {
      try {
        return localStorage.getItem(soundStorageKey) === 'on';
      } catch (error) {
        return false;
      }
    };
    const writeSoundPreference = () => {
      try {
        localStorage.setItem(soundStorageKey, soundEnabled ? 'on' : 'off');
      } catch (error) {
        // Sound is optional; storage failures should never block the builder.
      }
    };
    const ensureSoundContext = () => {
      if (!soundEnabled) return null;
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return null;
      try {
        if (!soundContext) soundContext = new AudioContext();
        if (soundContext.state === 'suspended') {
          const resume = soundContext.resume();
          if (resume && typeof resume.catch === 'function') resume.catch(() => {});
        }
        return soundContext;
      } catch (error) {
        soundEnabled = false;
        updateSoundToggle();
        return null;
      }
    };
    const playSound = (type) => {
      const audioContext = ensureSoundContext();
      if (!audioContext) return;
      const now = audioContext.currentTime;

      soundPattern(type).forEach((note) => {
        const oscillator = audioContext.createOscillator();
        const gain = audioContext.createGain();
        const startAt = now + (note.delay || 0);
        const stopAt = startAt + note.duration;

        oscillator.type = note.type || 'sine';
        oscillator.frequency.setValueAtTime(note.frequency, startAt);
        gain.gain.setValueAtTime(0.0001, startAt);
        gain.gain.exponentialRampToValueAtTime(note.gain, startAt + 0.008);
        gain.gain.exponentialRampToValueAtTime(0.0001, stopAt);
        oscillator.connect(gain);
        gain.connect(audioContext.destination);
        oscillator.start(startAt);
        oscillator.stop(stopAt + 0.02);
      });
    };

    const historySnapshot = () => selectedBeads.map((bead) => ({ ...bead }));
    const nextBeadInstanceId = () => `bead-${Date.now()}-${beadInstanceSeq += 1}`;
    const beadKey = (bead, index) => bead.instanceId || `${bead.variantId}:${bead.diameter}:${index}`;
    const snapshotSignature = (snapshot) => snapshot.map((bead, index) => beadKey(bead, index)).join('|');
    const designSignature = (beads = selectedBeads) => beads
      .map((bead) => `${Number(bead.variantId)}:${Number(bead.diameter || activeDiameter)}`)
      .join('|');
    const storedBeadsFor = (beads = selectedBeads) => beads.map((bead) => [
      Number(bead.variantId),
      Number(bead.diameter || activeDiameter)
    ]);
    const normalizeStoredBeads = (value) => {
      if (!Array.isArray(value)) return [];
      return value
        .map((item) => {
          if (!Array.isArray(item) || item.length < 2) return null;
          const variantId = Number(item[0]);
          const diameter = Number(item[1]);
          if (!Number.isFinite(variantId) || !Number.isFinite(diameter)) return null;
          return [variantId, diameter];
        })
        .filter(Boolean);
    };
    const normalizeSavedDesign = (value) => {
      const slot = Number(value && value.slot);
      if (!Number.isInteger(slot) || slot < 1 || slot > MAX_SAVED_DESIGNS) return null;
      return {
        slot,
        updatedAt: Number(value.updatedAt) || Date.now(),
        beads: normalizeStoredBeads(value.beads)
      };
    };
    const readSavedDesignState = () => {
      try {
        const rawState = localStorage.getItem(savedDesignStorageKey);
        if (!rawState) return;
        const parsedState = JSON.parse(rawState);
        if (!parsedState || parsedState.version !== 1) return;

        const slots = new Set();
        savedDesigns = (Array.isArray(parsedState.designs) ? parsedState.designs : [])
          .map(normalizeSavedDesign)
          .filter((design) => {
            if (!design || slots.has(design.slot)) return false;
            slots.add(design.slot);
            return true;
          })
          .sort((left, right) => left.slot - right.slot);

        if (parsedState.draft && typeof parsedState.draft === 'object') {
          const sourceSlot = Number(parsedState.draft.sourceSlot);
          savedDraft = {
            sourceSlot: Number.isInteger(sourceSlot) && sourceSlot >= 1 && sourceSlot <= MAX_SAVED_DESIGNS
              ? sourceSlot
              : null,
            updatedAt: Number(parsedState.draft.updatedAt) || Date.now(),
            beads: normalizeStoredBeads(parsedState.draft.beads)
          };
        }
      } catch (error) {
        storageAvailable = false;
        savedDesigns = [];
        savedDraft = null;
      }
    };
    const writeSavedDesignState = () => {
      if (!storageAvailable) return false;
      try {
        localStorage.setItem(savedDesignStorageKey, JSON.stringify({
          version: 1,
          designs: savedDesigns,
          draft: savedDraft
        }));
        return true;
      } catch (error) {
        storageAvailable = false;
        return false;
      }
    };
    const persistDraft = () => {
      const signature = `${activeDesignSlot || 0}:${designSignature()}`;
      if (signature === lastPersistedDraftSignature) return true;
      savedDraft = {
        sourceSlot: activeDesignSlot,
        updatedAt: Date.now(),
        beads: storedBeadsFor()
      };
      const didPersist = writeSavedDesignState();
      if (didPersist) lastPersistedDraftSignature = signature;
      return didPersist;
    };
    const findAvailableDesignSlot = () => {
      const usedSlots = new Set(savedDesigns.map((design) => design.slot));
      for (let slot = 1; slot <= MAX_SAVED_DESIGNS; slot += 1) {
        if (!usedSlots.has(slot)) return slot;
      }
      return null;
    };
    const findSavedDesign = (slot) => savedDesigns.find((design) => design.slot === Number(slot)) || null;
    const resolveStoredBeads = (storedBeads) => {
      let unavailableCount = 0;
      const beads = normalizeStoredBeads(storedBeads).flatMap(([variantId, diameter]) => {
        const style = beadLibrary.find((bead) => bead.variants.some((variant) => Number(variant.id) === variantId));
        const variant = style && style.variants.find((item) => Number(item.id) === variantId);
        const expectedDiameter = style
          ? isFixedSizeCharm(style)
            ? fixedDiameterForBead(style)
            : Number(variant && variant.size ? variant.size.replace('mm', '') : NaN)
          : NaN;
        if (!style || !variant || variant.available === false || expectedDiameter !== diameter) {
          unavailableCount += 1;
          return [];
        }
        return [{
          id: style.id,
          productId: style.productId,
          name: style.name,
          categories: style.categories,
          image: style.image || '',
          variantId: variant.id,
          priceCents: Number(variant.priceCents || 0),
          sku: variant.sku || '',
          diameter,
          instanceId: nextBeadInstanceId()
        }];
      });
      return { beads, unavailableCount };
    };

    const pushHistorySnapshot = (snapshot) => {
      history.push(snapshot.map((bead) => ({ ...bead })));
      if (history.length > 30) history.shift();
    };

    const saveHistory = () => {
      pushHistorySnapshot(historySnapshot());
    };

    const preloadImage = (bead) => {
      if (!bead.image || imageCache.has(bead.image)) return;
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = requestRender;
      image.src = bead.image;
      imageCache.set(bead.image, image);
    };

    const drawFallbackBead = (x, y, radius, bead, isSelected) => {
      const gradient = ctx.createRadialGradient(x - radius * 0.35, y - radius * 0.35, radius * 0.08, x, y, radius);
      gradient.addColorStop(0, '#ffffff');
      gradient.addColorStop(0.34, isSelected ? '#ead2c5' : '#dadde6');
      gradient.addColorStop(1, '#3a3f49');
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, Math.PI * 2);
      ctx.fill();
    };

    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
    const minimumBraceletRadiusPercent = clamp(
      Number(config.minimumBraceletRadiusPercent) || 23,
      18,
      28
    );
    const beadShadowIntensity = clamp(
      Number(config.beadShadowIntensityPercent ?? 100),
      0,
      150
    ) / 100;
    const beadShadowDistance = clamp(
      Number(config.beadShadowDistancePercent ?? 100),
      50,
      150
    ) / 100;
    const beadShadowSoftness = clamp(
      Number(config.beadShadowSoftnessPercent ?? 100),
      70,
      140
    ) / 100;
    const easeOutCubic = (value) => 1 - Math.pow(1 - value, 3);
    const distanceBetween = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);

    const naturalBeadRadius = (displaySize, bead) => {
      const size = Number(bead && bead.diameter ? bead.diameter : activeDiameter);
      return clamp((displaySize / 42) * (size / 8) * 1.3, 9, 42);
    };

    const beadGapRatioForCount = (count) => {
      if (count <= 6) return 0.55;
      if (count >= 16) return 0.03;
      return 0.55 - ((count - 6) / 10) * 0.52;
    };

    const getBraceletLayout = (displaySize, beads) => {
      const beadSet = beads.length ? beads : [{ diameter: activeDiameter }];
      const metrics = braceletMetrics(beadSet);
      const naturalRadii = beadSet.map((bead) => naturalBeadRadius(displaySize, bead));
      const averageRadius = naturalRadii.reduce((sum, radius) => sum + radius, 0) / naturalRadii.length;
      const beadCount = beadSet.length;
      const totalBeadDiameter = naturalRadii.reduce((sum, radius) => sum + radius * 2, 0);
      const targetGap = averageRadius * beadGapRatioForCount(beadCount);
      const targetCircumference = totalBeadDiameter + targetGap * beadCount;
      const pixelsPerCm = displaySize * 0.078;
      const lengthDrivenRadius = (metrics.braceletLengthCm * pixelsPerCm) / (Math.PI * 2);
      const fitDrivenRadius = (metrics.fitWristCm * pixelsPerCm) / (Math.PI * 2);
      const beadDrivenRadius = targetCircumference / (Math.PI * 2);
      const fewBeadMinimumRadius = averageRadius * (beadCount <= 2 ? 2.8 : beadCount <= 4 ? 2.35 : 1.55);
      const minBraceletRadius = displaySize * (minimumBraceletRadiusPercent / 100);
      const maxBraceletRadius = displaySize * 0.375;
      const naturalBraceletRadius = Math.max(
        beadDrivenRadius,
        lengthDrivenRadius * 0.82,
        fitDrivenRadius + averageRadius * 0.14,
        fewBeadMinimumRadius,
        minBraceletRadius
      );
      const scale = naturalBraceletRadius > maxBraceletRadius ? maxBraceletRadius / naturalBraceletRadius : 1;
      const beadRadii = naturalRadii.map((radius) => Math.max(4.5, radius * scale));
      const braceletRadius = naturalBraceletRadius * scale;

      return {
        center: displaySize / 2,
        beadRadii,
        braceletRadius,
        targetGap: targetGap * scale
      };
    };

    const beadAnglesForLayout = (layout) => {
      const beadCount = layout.beadRadii.length;
      if (beadCount <= 1) return [-Math.PI / 2];

      const segmentWeights = layout.beadRadii.map((currentRadius, index) => {
        const nextRadius = layout.beadRadii[(index + 1) % beadCount];
        return currentRadius + nextRadius + layout.targetGap;
      });
      const totalWeight = segmentWeights.reduce((sum, weight) => sum + weight, 0);
      const segmentAngles = segmentWeights.map((weight) => (weight / totalWeight) * Math.PI * 2);
      const angles = [-Math.PI / 2];

      for (let index = 1; index < beadCount; index += 1) {
        angles.push(angles[index - 1] + segmentAngles[index - 1]);
      }

      return angles;
    };

    const beadPosition = (layout, angle) => {
      return {
        x: layout.center + Math.cos(angle) * layout.braceletRadius,
        y: layout.center + Math.sin(angle) * layout.braceletRadius
      };
    };

    const beadRotationForPosition = (center, position) => {
      const mathAngle = Math.atan2(center - position.y, position.x - center);
      const normalizedMathAngle = (mathAngle + Math.PI * 2) % (Math.PI * 2);
      return (Math.PI - normalizedMathAngle + Math.PI * 2) % (Math.PI * 2);
    };

    const drawBraceletString = (layout, averageBeadRadius) => {
      const stringWidth = Math.max(2.4, averageBeadRadius * 0.16);

      ctx.save();
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';

      ctx.shadowColor = 'rgba(18, 21, 26, 0.16)';
      ctx.shadowBlur = Math.max(4, averageBeadRadius * 0.42);
      ctx.shadowOffsetX = -averageBeadRadius * 0.08;
      ctx.shadowOffsetY = averageBeadRadius * 0.18;
      ctx.strokeStyle = 'rgba(42, 45, 50, 0.12)';
      ctx.lineWidth = stringWidth * 1.55;
      ctx.beginPath();
      ctx.arc(layout.center, layout.center, layout.braceletRadius, 0, Math.PI * 2);
      ctx.stroke();

      ctx.shadowColor = 'transparent';
      ctx.shadowBlur = 0;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
      ctx.strokeStyle = 'rgba(231, 233, 236, 0.72)';
      ctx.lineWidth = stringWidth;
      ctx.beginPath();
      ctx.arc(layout.center, layout.center, layout.braceletRadius, 0, Math.PI * 2);
      ctx.stroke();

      ctx.strokeStyle = 'rgba(255, 255, 255, 0.32)';
      ctx.lineWidth = Math.max(1, stringWidth * 0.34);
      ctx.beginPath();
      ctx.arc(layout.center, layout.center, layout.braceletRadius - stringWidth * 0.34, 0, Math.PI * 2);
      ctx.stroke();
      ctx.restore();
    };

    const drawBeadShadow = (x, y, radius, alpha, shadowStrength) => {
      const strength = shadowStrength * alpha * beadShadowIntensity;
      const offsetX = radius * 0.22 * beadShadowDistance;
      const offsetY = radius * 0.34 * beadShadowDistance;

      ctx.save();
      ctx.translate(x + offsetX, y + offsetY);
      ctx.scale(1.05, 0.42);
      const spreadGradient = ctx.createRadialGradient(
        0,
        0,
        radius * 0.08,
        0,
        0,
        radius * 1.04 * beadShadowSoftness
      );
      spreadGradient.addColorStop(0, `rgba(17, 19, 23, ${0.14 * strength})`);
      spreadGradient.addColorStop(0.42, `rgba(17, 19, 23, ${0.07 * strength})`);
      spreadGradient.addColorStop(1, 'rgba(17, 19, 23, 0)');
      ctx.fillStyle = spreadGradient;
      ctx.beginPath();
      ctx.arc(0, 0, radius * 1.04 * beadShadowSoftness, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();

      ctx.save();
      ctx.translate(
        x + radius * 0.14 * beadShadowDistance,
        y + radius * 0.24 * beadShadowDistance
      );
      ctx.scale(0.68, 0.28);
      const contactGradient = ctx.createRadialGradient(
        0,
        0,
        radius * 0.06,
        0,
        0,
        radius * 0.82 * beadShadowSoftness
      );
      contactGradient.addColorStop(0, `rgba(17, 19, 23, ${0.18 * strength})`);
      contactGradient.addColorStop(0.48, `rgba(17, 19, 23, ${0.08 * strength})`);
      contactGradient.addColorStop(1, 'rgba(17, 19, 23, 0)');
      ctx.fillStyle = contactGradient;
      ctx.beginPath();
      ctx.arc(0, 0, radius * 0.82 * beadShadowSoftness, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    };

    const drawBead = (bead, x, y, radius, isSelected, options = {}) => {
      const alpha = options.alpha === undefined ? 1 : options.alpha;
      const rotation = options.rotation || 0;
      const baseRadius = radius * (isSelected && !options.disableSelectionLift ? 1.035 : 1);
      const shadowStrength = options.shadowStrength || (isSelected ? 1.08 : 1);
      const cachedImage = bead.image ? imageCache.get(bead.image) : null;
      const hasImage = cachedImage && cachedImage.complete && cachedImage.naturalWidth > 0;

      ctx.save();
      ctx.globalAlpha = alpha;
      drawBeadShadow(x, y, baseRadius, alpha, shadowStrength);

      ctx.save();
      ctx.beginPath();
      ctx.arc(x, y, baseRadius, 0, Math.PI * 2);
      ctx.closePath();
      ctx.clip();

      if (hasImage) {
        ctx.translate(x, y);
        ctx.rotate(rotation);
        ctx.drawImage(cachedImage, -baseRadius, -baseRadius, baseRadius * 2, baseRadius * 2);
      } else {
        drawFallbackBead(x, y, baseRadius, bead, isSelected);
      }

      ctx.restore();

      ctx.restore();
    };

    const renderHitTargets = (displaySize) => {
      if (!hitLayer) return;
      const nextHitTargetSignature = displaySize && hitRegions.length
        ? hitRegions
            .map((region) => [
              region.key,
              region.index,
              Math.round(region.x),
              Math.round(region.y),
              Math.round(region.radius),
              dragState && dragState.dragIndex === region.index ? 'dragging' : ''
            ].join(':'))
            .join('|')
        : 'empty';

      if (nextHitTargetSignature === hitTargetSignature) return;
      hitTargetSignature = nextHitTargetSignature;
      hitLayer.innerHTML = '';
      if (!displaySize || !hitRegions.length) return;

      hitRegions.forEach((region) => {
        const hitRadius = region.radius + 10;
        const hitSize = (hitRadius * 2 / displaySize) * 100;
        const hitTarget = document.createElement('button');
        hitTarget.type = 'button';
        hitTarget.className = `stone-builder__hit-target${dragState && dragState.dragIndex === region.index ? ' is-dragging' : ''}`;
        hitTarget.dataset.beadIndex = String(region.index);
        hitTarget.setAttribute('aria-label', `Move bead ${region.index + 1}`);
        hitTarget.style.width = `${hitSize}%`;
        hitTarget.style.height = `${hitSize}%`;
        hitTarget.style.left = `${((region.x - hitRadius) / displaySize) * 100}%`;
        hitTarget.style.top = `${((region.y - hitRadius) / displaySize) * 100}%`;
        hitLayer.appendChild(hitTarget);
      });
    };

    const renderCanvas = () => {
      pendingFrame = null;
      const rect = canvas.getBoundingClientRect();
      const ratio = window.devicePixelRatio || 1;
      const displaySize = Math.max(280, Math.round(rect.width || 720));
      const pixelSize = Math.round(displaySize * ratio);

      if (canvas.width !== pixelSize || canvas.height !== pixelSize) {
        canvas.width = pixelSize;
        canvas.height = pixelSize;
      }

      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      ctx.clearRect(0, 0, displaySize, displaySize);
      hitRegions = [];

      if (!selectedBeads.length) {
        renderHitTargets(displaySize);
        return;
      }

      const layout = getBraceletLayout(displaySize, selectedBeads);
      const now = performance.now();
      const motionProgress = beadMotion ? (now - beadMotion.startedAt) / beadMotion.duration : 1;
      const hasActiveMotion = beadMotion && beadMotion.index < selectedBeads.length && motionProgress < 1;
      const layoutProgress = layoutMotion ? (now - layoutMotion.startedAt) / layoutMotion.duration : 1;
      const hasLayoutMotion = layoutMotion && layoutProgress < 1;
      const layoutEase = hasLayoutMotion ? easeOutCubic(clamp(layoutProgress, 0, 1)) : 1;
      let movingTarget = null;

      if (!hasActiveMotion) beadMotion = null;
      if (!hasLayoutMotion) layoutMotion = null;

      const averageBeadRadius = layout.beadRadii.reduce((sum, radius) => sum + radius, 0) / layout.beadRadii.length;
      drawBraceletString(layout, averageBeadRadius);
      const beadAngles = beadAnglesForLayout(layout);

      let draggedBead = null;
      let draggedRadius = averageBeadRadius;
      selectedBeads.forEach((bead, index) => {
        const targetPosition = beadPosition(layout, beadAngles[index]);
        const key = beadKey(bead, index);
        const fromPosition = hasLayoutMotion ? layoutMotion.fromByKey.get(key) : null;
        const position = fromPosition
          ? {
              x: fromPosition.x + (targetPosition.x - fromPosition.x) * layoutEase,
              y: fromPosition.y + (targetPosition.y - fromPosition.y) * layoutEase
            }
          : targetPosition;
        const beadRadius = layout.beadRadii[index] || averageBeadRadius;
        let drawPosition = position;

        if (dragState && dragState.hasMoved && index === dragState.dragIndex) {
          draggedBead = bead;
          draggedRadius = beadRadius;
          hitRegions.push({ ...targetPosition, radius: beadRadius, index, key });
          return;
        }

        if (hasActiveMotion && index === beadMotion.index) {
          movingTarget = { bead, ...targetPosition };
          hitRegions.push({ ...targetPosition, radius: beadRadius, index, key });
          return;
        }

        drawBead(bead, drawPosition.x, drawPosition.y, beadRadius, index === selectedIndex, {
          rotation: beadRotationForPosition(layout.center, drawPosition)
        });
        hitRegions.push({ ...targetPosition, radius: beadRadius, index, key });
      });

      if (hasActiveMotion && movingTarget) {
        const progress = clamp(motionProgress, 0, 1);
        const eased = easeOutCubic(progress);
        const direction = movingTarget.x < layout.center ? -1 : 1;
        const startX = beadMotion.fromX || layout.center;
        const targetRadius = layout.beadRadii[beadMotion.index] || averageBeadRadius;
        const startY = beadMotion.fromY || displaySize + targetRadius * 2;
        const arcLift = Math.sin(eased * Math.PI) * displaySize * 0.05 * direction;
        const x = startX + (movingTarget.x - startX) * eased + arcLift;
        const y = startY + (movingTarget.y - startY) * eased;
        const radius = targetRadius * (0.72 + 0.28 * eased);

        drawBead(movingTarget.bead, x, y, radius, true, {
          alpha: 0.35 + 0.65 * eased,
          rotation: progress * Math.PI * 1.8,
          shadowStrength: 1.05
        });
        requestRender();
      }

      if (draggedBead && dragState) {
        drawBead(draggedBead, dragState.currentX, dragState.currentY, draggedRadius * (dragState.deletePreview ? 0.86 : 1.08), true, {
          alpha: dragState.deletePreview ? 0.48 : 0.92,
          shadowStrength: dragState.deletePreview ? 0.8 : 1.12,
          disableSelectionLift: dragState.deletePreview
        });
      }

      if (hasLayoutMotion) requestRender();
      renderHitTargets(displaySize);
    };

    function requestRender() {
      if (pendingFrame) return;
      pendingFrame = window.requestAnimationFrame(renderCanvas);
    }

    const filteredLibrary = () => {
      return beadLibrary
        .filter((bead) => activeCategory === 'All' || bead.categories.includes(activeCategory))
        .sort((leftBead, rightBead) => {
          const leftAvailable = Boolean(beadVariantForDiameter(leftBead, activeDiameter));
          const rightAvailable = Boolean(beadVariantForDiameter(rightBead, activeDiameter));
          return Number(rightAvailable) - Number(leftAvailable);
        });
    };

    const renderCategories = () => {
      categoriesEl.innerHTML = '';
      categoryList().forEach((category) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `stone-builder__category${category === activeCategory ? ' is-active' : ''}`;
        button.dataset.category = category;
        button.textContent = category;
        categoriesEl.appendChild(button);
      });
    };

    const renderDiameterButtons = () => {
      diameterGroup.innerHTML = '';
      supportedDiameters.forEach((diameter) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `stone-builder__diameter-button${diameter === activeDiameter ? ' is-active' : ''}`;
        button.dataset.diameter = String(diameter);
        button.textContent = diameterLabel(diameter);
        diameterGroup.appendChild(button);
      });
    };

    const renderGrid = () => {
      gridEl.innerHTML = '';
      filteredLibrary().forEach((bead) => {
        const card = document.createElement('button');
        const title = document.createElement('span');
        const meta = document.createElement('span');
        const resolvedBead = resolvedBeadForDiameter(bead, activeDiameter);
        const available = Boolean(resolvedBead);
        const displayDiameter = isFixedSizeCharm(bead) ? fixedDiameterForBead(bead, activeDiameter) : activeDiameter;

        card.type = 'button';
        card.className = `stone-builder__card${bead.id === selectedLibraryId ? ' is-selected' : ''}${available ? '' : ' is-unavailable'}`;
        card.dataset.beadId = bead.id;
        card.disabled = !available;

        if (bead.image) {
          const image = document.createElement('img');
          image.className = 'stone-builder__card-thumb';
          image.src = bead.image;
          image.alt = bead.name;
          image.loading = 'lazy';
          card.appendChild(image);
        } else {
          const fallback = document.createElement('span');
          fallback.className = 'stone-builder__card-fallback';
          fallback.textContent = bead.name.charAt(0).toUpperCase();
          card.appendChild(fallback);
        }

        title.className = 'stone-builder__card-name';
        title.textContent = bead.name;
        meta.className = 'stone-builder__card-meta';
        if (available) {
          meta.innerHTML = `${diameterLabel(displayDiameter)} - <strong>${formatMoney(resolvedBead.priceCents)}</strong>`;
        } else if (isFixedSizeCharm(bead)) {
          meta.textContent = 'Unavailable';
        } else {
          meta.textContent = `Not available in ${diameterLabel()}`;
        }

        card.append(title, meta);
        gridEl.appendChild(card);
      });
      updateGridRows();
    };

    const updateGridRows = () => {
      const cards = Array.from(gridEl.querySelectorAll('.stone-builder__card'));
      if (!cards.length) {
        gridEl.classList.remove('is-two-row');
        return;
      }

      const styles = window.getComputedStyle(gridEl);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || 0) || 0;
      const cardWidth = cards[0].getBoundingClientRect().width || 0;
      const neededWidth = cards.length * cardWidth + Math.max(0, cards.length - 1) * gap;
      gridEl.classList.toggle('is-two-row', neededWidth > gridEl.clientWidth + 1);
    };

    const currentDesignHasChanges = () => activeDesignSlot !== null
      && designSignature() !== activeDesignSignature;
    const currentWorkNeedsConfirmation = () => selectedBeads.length > 0
      && (activeDesignSlot === null || currentDesignHasChanges());
    const showTemporaryStatus = (message, duration = 2200) => {
      window.clearTimeout(statusOverrideTimer);
      statusOverride = message;
      syncUi();
      statusOverrideTimer = window.setTimeout(() => {
        statusOverride = '';
        syncUi();
      }, duration);
    };
    const showSaveNotice = () => {
      window.clearTimeout(designSaveNoticeTimer);
      designSaveButton.textContent = 'Saved · My designs';
      designSaveNoticeTimer = window.setTimeout(() => {
        updateDesignBar();
      }, 1400);
    };
    const updateDesignBar = () => {
      designsCountEl.textContent = String(savedDesigns.length);
      designSaveButton.textContent = activeDesignSlot === null ? 'Save' : 'Update';
      designSaveButton.disabled = !storageAvailable
        || selectedBeads.length === 0
        || (activeDesignSlot !== null && !currentDesignHasChanges())
        || (activeDesignSlot === null && findAvailableDesignSlot() === null);
    };
    const toggleSound = () => {
      soundEnabled = !soundEnabled;
      writeSoundPreference();
      updateSoundToggle();
      if (soundEnabled) playSound('tap');
    };
    const renderDesignPreview = (beads) => {
      const preview = document.createElement('span');
      preview.className = 'stone-builder__design-preview';
      preview.setAttribute('aria-hidden', 'true');
      beads.slice(0, 12).forEach((bead) => {
        if (bead.image) {
          const image = document.createElement('img');
          image.src = bead.image;
          image.alt = '';
          image.loading = 'lazy';
          preview.appendChild(image);
        } else {
          const fallback = document.createElement('span');
          fallback.className = 'stone-builder__design-preview-fallback';
          preview.appendChild(fallback);
        }
      });
      if (beads.length > 12) {
        const remainder = document.createElement('span');
        remainder.className = 'stone-builder__design-preview-more';
        remainder.textContent = `+${beads.length - 12}`;
        preview.appendChild(remainder);
      }
      return preview;
    };
    const renderSavedDesigns = () => {
      designsList.innerHTML = '';
      designsMessage.textContent = '';

      if (!savedDesigns.length) {
        const empty = document.createElement('p');
        empty.className = 'stone-builder__designs-empty';
        empty.textContent = 'No saved designs';
        designsList.appendChild(empty);
      }

      savedDesigns.forEach((design) => {
        const resolved = resolveStoredBeads(design.beads);
        const item = document.createElement('div');
        const loadButton = document.createElement('button');
        const text = document.createElement('span');
        const title = document.createElement('strong');
        const meta = document.createElement('span');
        const deleteButton = document.createElement('button');

        item.className = `stone-builder__design-item${design.slot === activeDesignSlot ? ' is-active' : ''}`;
        loadButton.type = 'button';
        loadButton.className = 'stone-builder__design-load';
        loadButton.dataset.designSlot = String(design.slot);
        loadButton.setAttribute('aria-label', `Load Design ${design.slot}`);
        title.textContent = `Design ${design.slot}`;
        meta.textContent = resolved.unavailableCount
          ? `${resolved.beads.length} beads · Some unavailable`
          : `${resolved.beads.length} beads`;
        text.className = 'stone-builder__design-text';
        text.append(title, meta);
        loadButton.append(renderDesignPreview(resolved.beads), text);

        deleteButton.type = 'button';
        deleteButton.className = 'stone-builder__design-delete';
        deleteButton.dataset.deleteDesignSlot = String(design.slot);
        deleteButton.setAttribute('aria-label', `Delete Design ${design.slot}`);
        deleteButton.textContent = 'Delete';
        item.append(loadButton, deleteButton);
        designsList.appendChild(item);
      });

      designCopyButton.disabled = !storageAvailable
        || selectedBeads.length === 0
        || findAvailableDesignSlot() === null;
      designNewButton.disabled = !storageAvailable || findAvailableDesignSlot() === null;
      if (!storageAvailable) {
        designsMessage.textContent = 'Saving is unavailable in this browser.';
      } else if (findAvailableDesignSlot() === null) {
        designsMessage.textContent = 'Delete a design to save a copy.';
      }
    };
    const openDesignsModal = () => {
      renderSavedDesigns();
      designModalPreviousFocus = document.activeElement;
      designModalPreviousBodyOverflow = document.body.style.overflow;
      designsModal.hidden = false;
      document.body.style.overflow = 'hidden';
      designsCloseButton.focus();
    };
    const closeDesignsModal = (restoreFocus = true) => {
      designsModal.hidden = true;
      document.body.style.overflow = designModalPreviousBodyOverflow;
      if (restoreFocus && designModalPreviousFocus && typeof designModalPreviousFocus.focus === 'function') {
        designModalPreviousFocus.focus();
      }
    };
    const closeSwitchModal = (restoreFocus = true) => {
      switchModal.hidden = true;
      pendingDesignSlot = null;
      if (restoreFocus) designsCloseButton.focus();
    };
    const saveCurrentDesign = (asCopy = false) => {
      if (!storageAvailable) {
        showTemporaryStatus('Saving is unavailable in this browser.');
        return;
      }
      if (!selectedBeads.length) return;
      const slot = asCopy || activeDesignSlot === null ? findAvailableDesignSlot() : activeDesignSlot;
      if (slot === null) {
        designsMessage.textContent = 'Delete a design to save a copy.';
        return;
      }

      const previousDesigns = savedDesigns.map((item) => ({
        ...item,
        beads: item.beads.map((bead) => [...bead])
      }));
      const previousDraft = savedDraft;
      const previousActiveSlot = activeDesignSlot;
      const previousActiveSignature = activeDesignSignature;
      const design = {
        slot,
        updatedAt: Date.now(),
        beads: storedBeadsFor()
      };
      const existingIndex = savedDesigns.findIndex((item) => item.slot === slot);
      if (existingIndex >= 0) savedDesigns[existingIndex] = design;
      else savedDesigns.push(design);
      savedDesigns.sort((left, right) => left.slot - right.slot);
      activeDesignSlot = slot;
      activeDesignSignature = designSignature();
      lastPersistedDraftSignature = '';
      if (!persistDraft()) {
        savedDesigns = previousDesigns;
        savedDraft = previousDraft;
        activeDesignSlot = previousActiveSlot;
        activeDesignSignature = previousActiveSignature;
        lastPersistedDraftSignature = '';
        updateDesignBar();
        renderSavedDesigns();
        showTemporaryStatus('Saving is unavailable in this browser.');
        return;
      }
      updateDesignBar();
      renderSavedDesigns();
      showSaveNotice();
      playSound('saved');
    };
    const loadSavedDesign = (slot) => {
      const design = findSavedDesign(slot);
      if (!design) return;
      const resolved = resolveStoredBeads(design.beads);
      selectedBeads = resolved.beads;
      selectedIndex = 0;
      activeDesignSlot = design.slot;
      activeDesignSignature = designSignature();
      history = [];
      beadMotion = null;
      layoutMotion = null;
      statusOverride = '';
      lastPersistedDraftSignature = '';
      persistDraft();
      closeSwitchModal(false);
      closeDesignsModal();
      syncUi();
      if (resolved.unavailableCount) showTemporaryStatus('Some beads are unavailable.');
    };
    const startNewDesign = () => {
      selectedBeads = [];
      selectedIndex = 0;
      activeDesignSlot = null;
      activeDesignSignature = '';
      history = [];
      beadMotion = null;
      layoutMotion = null;
      statusOverride = '';
      lastPersistedDraftSignature = '';
      persistDraft();
      closeSwitchModal(false);
      closeDesignsModal();
      syncUi();
    };
    const requestNewDesign = () => {
      if (currentWorkNeedsConfirmation()) {
        pendingDesignSlot = 'new';
        switchModal.hidden = false;
        switchKeepButton.focus();
        return;
      }
      startNewDesign();
    };
    const requestDesignLoad = (slot) => {
      if (Number(slot) === activeDesignSlot && !currentDesignHasChanges()) {
        closeDesignsModal();
        return;
      }
      if (currentWorkNeedsConfirmation()) {
        pendingDesignSlot = Number(slot);
        switchModal.hidden = false;
        switchKeepButton.focus();
        return;
      }
      loadSavedDesign(slot);
    };
    const deleteSavedDesign = (slot) => {
      const numericSlot = Number(slot);
      savedDesigns = savedDesigns.filter((design) => design.slot !== numericSlot);
      if (activeDesignSlot === numericSlot) {
        activeDesignSlot = null;
        activeDesignSignature = '';
      }
      lastPersistedDraftSignature = '';
      persistDraft();
      updateDesignBar();
      renderSavedDesigns();
    };
    const trapFocus = (container, event) => {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(container.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((element) => !element.hidden);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    const syncUi = () => {
      beadLibrary.forEach(preloadImage);
      selectedBeads.forEach((bead) => {
        if (!bead.instanceId) bead.instanceId = nextBeadInstanceId();
      });
      selectedIndex = Math.max(0, Math.min(selectedIndex, selectedBeads.length - 1));
      const metrics = braceletMetrics();
      totalEl.textContent = formatMoneyWithCurrency(totalCents());
      countEl.textContent = String(selectedBeads.length);
      wristEl.textContent = formatFitSize(metrics.fitWristCm);
      emptyState.classList.toggle('is-visible', beadLibrary.length === 0);

      const minimum = Number(config.minimumBeads || 9);
      const baseReady = config.baseItem && config.baseItem.variantId;
      const ready = baseReady && beadLibrary.length > 0;
      const availableNow = beadLibrary.filter((bead) => beadVariantForDiameter(bead, activeDiameter)).length;
      removeButton.disabled = selectedBeads.length === 0;
      undoButton.disabled = history.length === 0;
      submitButton.disabled = !ready;
      updateDesignBar();
      persistDraft();

      if (!baseReady) {
        statusEl.textContent = 'Choose a base product in the section settings before customers can add to cart.';
      } else if (beadLibrary.length === 0) {
        statusEl.textContent = 'Add at least one valid bead item in the theme editor.';
      } else if (availableNow === 0) {
        statusEl.textContent = `No bead items are available in ${diameterLabel()} yet.`;
      } else if (statusOverride) {
        statusEl.textContent = statusOverride;
      } else if (selectedBeads.length < minimum) {
        const remaining = minimum - selectedBeads.length;
        statusEl.textContent = `Add ${remaining} more bead${remaining === 1 ? '' : 's'} to complete your bracelet.`;
      } else {
        statusEl.textContent = 'Your bracelet is ready to add to cart.';
      }

      renderCategories();
      renderGrid();
      requestRender();
    };

    const addBead = (bead) => {
      if (!bead) return;
      const insertIndex = selectedBeads.length ? selectedIndex + 1 : 0;
      const projectedBeads = selectedBeads.slice();
      const insertedBead = { ...bead, instanceId: nextBeadInstanceId() };
      projectedBeads.splice(insertIndex, 0, insertedBead);
      if (braceletMetrics(projectedBeads).fitWristCm > MAX_FIT_WRIST_CM) {
        statusOverride = maxFitMessage();
        syncUi();
        return;
      }

      statusOverride = '';
      saveHistory();
      selectedBeads.splice(insertIndex, 0, insertedBead);
      selectedIndex = insertIndex;
      playSound('add');
      beadMotion = {
        bead: insertedBead,
        index: insertIndex,
        startedAt: performance.now(),
        duration: 520
      };
      syncUi();
    };

    const clearBracelet = () => {
      if (!selectedBeads.length) return;
      statusOverride = '';
      saveHistory();
      playSound('remove');
      beadMotion = null;
      layoutMotion = null;
      selectedBeads = [];
      selectedIndex = 0;
      syncUi();
    };

    const undo = () => {
      const previous = history.pop();
      if (!previous) return;
      statusOverride = '';
      beadMotion = null;
      layoutMotion = null;
      selectedBeads = previous.map((bead) => ({ ...bead }));
      syncUi();
    };

    const canvasToBlob = (sourceCanvas, type, quality) => {
      return new Promise((resolve) => {
        try {
          sourceCanvas.toBlob((blob) => resolve(blob), type, quality);
        } catch (error) {
          resolve(null);
        }
      });
    };

    const previewCaptureStorageKey = (designId) => `${previewCaptureStoragePrefix}${String(designId || '').toLowerCase()}`;

    const canvasToDataUrl = (sourceCanvas, type, quality) => {
      try {
        return sourceCanvas.toDataURL(type, quality);
      } catch (error) {
        return '';
      }
    };

    const createBraceletPreviewCanvas = async (size) => {
      beadMotion = null;
      layoutMotion = null;
      renderCanvas();

      const previewCanvas = document.createElement('canvas');
      previewCanvas.width = size;
      previewCanvas.height = size;
      const previewContext = previewCanvas.getContext('2d');
      if (!previewContext) return null;

      previewContext.fillStyle = '#ffffff';
      previewContext.fillRect(0, 0, previewCanvas.width, previewCanvas.height);
      previewContext.imageSmoothingEnabled = true;
      previewContext.imageSmoothingQuality = 'high';
      previewContext.drawImage(canvas, 0, 0, previewCanvas.width, previewCanvas.height);

      return previewCanvas;
    };

    const scaleBraceletPreviewCanvas = (sourceCanvas, size) => {
      if (!sourceCanvas) return null;

      const scaledCanvas = document.createElement('canvas');
      scaledCanvas.width = size;
      scaledCanvas.height = size;
      const scaledContext = scaledCanvas.getContext('2d');
      if (!scaledContext) return null;

      scaledContext.fillStyle = '#ffffff';
      scaledContext.fillRect(0, 0, size, size);
      scaledContext.imageSmoothingEnabled = true;
      scaledContext.imageSmoothingQuality = 'high';
      scaledContext.drawImage(sourceCanvas, 0, 0, size, size);

      return scaledCanvas;
    };

    const createBraceletPreviewAssets = async () => {
      const captureCanvas = await createBraceletPreviewCanvas(previewCaptureSize);
      if (!captureCanvas) return null;

      const captureDataUrl = canvasToDataUrl(captureCanvas, 'image/webp', previewCaptureQuality)
        || canvasToDataUrl(captureCanvas, 'image/png');
      if (!captureDataUrl) return null;

      const uploadCanvas = scaleBraceletPreviewCanvas(captureCanvas, previewUploadSize);
      const uploadBlob = uploadCanvas
        ? await canvasToBlob(uploadCanvas, 'image/webp', previewUploadQuality)
          || await canvasToBlob(uploadCanvas, 'image/png')
        : null;

      return {
        captureDataUrl,
        uploadBlob
      };
    };

    const uploadBraceletPreview = async (previewKey, blob) => {
      if (!blob) return '';

      if (navigator.sendBeacon && blob.type === 'image/webp') {
        const queued = navigator.sendBeacon(`${previewUploadEndpoint}?key=${encodeURIComponent(previewKey)}`, blob);
        if (queued) return previewUrlForKey(previewKey);
      }

      const response = await fetch(`${previewUploadEndpoint}?key=${encodeURIComponent(previewKey)}`, {
        method: 'POST',
        headers: {
          'Content-Type': blob.type || 'image/png',
          Accept: 'application/json'
        },
        body: blob,
        keepalive: true
      });

      if (!response.ok) throw new Error('Preview upload failed');
      const payload = await response.json();
      return payload && payload.url ? String(payload.url) : '';
    };

    const createDesignId = () => {
      return `SCB-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    };

    const previewKeyForDesign = (designId) => {
      const dateFolder = new Date().toISOString().slice(0, 10);
      return `bracelet-previews/${dateFolder}/${String(designId).toLowerCase()}.webp`;
    };

    const previewUrlForKey = (key) => {
      return `${previewBaseUrl}${key}`;
    };

    const buildDesignJson = (designId) => {
      const variants = Array.from(new Set(selectedBeads.map((bead) => Number(bead.variantId))));
      return {
        version: 1,
        designId,
        variants,
        beadSizes: sizeSummary(),
        fitSizeCm: wristSize(),
        braceletLengthCm: braceletLength(),
        beads: selectedBeads.map((bead) => [
          variants.indexOf(Number(bead.variantId)),
          Number(bead.diameter || activeDiameter)
        ])
      };
    };

    const buildCartItems = (designId, previewUrl = '') => {
      const beadSummary = selectedBeads.map((bead) => `${bead.name} ${diameterLabel(bead.diameter)}`).join(', ');
      const groupedBeads = new Map();
      const baseProperties = {
        _scb_design_id: designId,
        _scb_role: 'base',
        _scb_preview_url: previewUrl,
        _scb_design_json: JSON.stringify(buildDesignJson(designId)),
        'Bead sizes': sizeSummary(),
        'Estimated Fit': formatFitSize(braceletMetrics().fitWristCm),
        'Bracelet Length': formatMeasurement(braceletMetrics().braceletLengthCm),
        Beads: beadSummary
      };

      selectedBeads.forEach((bead) => {
        const key = String(bead.variantId);
        const existing = groupedBeads.get(key);
        if (existing) {
          existing.quantity += 1;
        } else {
          groupedBeads.set(key, {
            id: Number(bead.variantId),
            quantity: 1,
            properties: {
              _scb_design_id: designId,
              _scb_role: 'bead',
              _scb_bead_name: bead.name,
              'Bead size': diameterLabel(bead.diameter)
            }
          });
        }
      });

      return [
        {
          id: Number(config.baseItem.variantId),
          quantity: 1,
          properties: baseProperties
        },
        ...Array.from(groupedBeads.values())
      ];
    };

    const showMinimumModal = () => {
      const minimum = Number(config.minimumBeads || 9);
      const remaining = Math.max(0, minimum - selectedBeads.length);
      modalMessage.textContent = `Please add at least ${minimum} beads to complete your bracelet. You need ${remaining} more bead${remaining === 1 ? '' : 's'} before checkout.`;
      modal.hidden = false;
      modalCloseButton.focus();
    };

    const hideMinimumModal = () => {
      modal.hidden = true;
      submitButton.focus();
    };

    const selectSizeGuideTab = (tabName, shouldFocus = false) => {
      sizeGuideTabs.forEach((tab) => {
        const isActive = tab.dataset.stoneBuilderSizeGuideTab === tabName;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
        if (isActive && shouldFocus) tab.focus();
      });

      sizeGuidePanels.forEach((panel) => {
        panel.hidden = panel.dataset.stoneBuilderSizeGuidePanel !== tabName;
      });
    };

    const openSizeGuide = () => {
      sizeGuidePreviousBodyOverflow = document.body.style.overflow;
      selectSizeGuideTab('wrist');
      sizeGuideModal.hidden = false;
      document.body.style.overflow = 'hidden';
      sizeGuideCloseButton.focus();
    };

    const closeSizeGuide = () => {
      sizeGuideModal.hidden = true;
      document.body.style.overflow = sizeGuidePreviousBodyOverflow;
      sizeGuideOpenButton.focus();
    };

    const trapSizeGuideFocus = (event) => {
      if (event.key !== 'Tab' || sizeGuideModal.hidden) return;

      const focusable = [
        sizeGuideCloseButton,
        ...sizeGuideTabs.filter((tab) => tab.tabIndex === 0)
      ];
      const firstFocusable = focusable[0];
      const lastFocusable = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    };

    const handleSizeGuideTabKeydown = (event) => {
      const currentIndex = sizeGuideTabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % sizeGuideTabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + sizeGuideTabs.length) % sizeGuideTabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = sizeGuideTabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      selectSizeGuideTab(sizeGuideTabs[nextIndex].dataset.stoneBuilderSizeGuideTab, true);
    };

    const submitCart = async () => {
      if (selectedBeads.length < Number(config.minimumBeads || 9)) {
        showMinimumModal();
        return;
      }

      submitButton.disabled = true;
      statusEl.textContent = 'Adding your bracelet to the cart...';

      try {
        const designId = createDesignId();
        const previewKey = previewKeyForDesign(designId);
        const previewUrl = previewUrlForKey(previewKey);
        const previewAssets = await createBraceletPreviewAssets();
        if (previewAssets && previewAssets.captureDataUrl) {
          try {
            sessionStorage.setItem(previewCaptureStorageKey(designId), previewAssets.captureDataUrl);
          } catch (error) {
            // Ignore storage quota/session availability errors and continue checkout flow.
          }
        }
        uploadBraceletPreview(previewKey, previewAssets && previewAssets.uploadBlob).catch(() => {});

        const response = await fetch(`${window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add'}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: buildCartItems(designId, previewUrl) })
        });

        if (!response.ok) throw new Error('Cart add failed');
        window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
      } catch (error) {
        statusEl.textContent = 'The bracelet could not be added just now. Please check the product setup and try again.';
        submitButton.disabled = false;
      }
    };

    const canvasPoint = (event) => {
      const rect = canvas.getBoundingClientRect();
      return {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top,
        size: Math.max(280, Math.round(rect.width || 720))
      };
    };

    const hitRegionAtPoint = (point) => {
      return hitRegions.find((region) => Math.hypot(region.x - point.x, region.y - point.y) <= region.radius + 10);
    };

    const currentHitRegionMap = () => {
      return new Map(hitRegions.map((region) => [region.key, { x: region.x, y: region.y }]));
    };

    const swapBeads = (fromIndex, toIndex) => {
      if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) return;
      const fromByKey = currentHitRegionMap();
      const bead = selectedBeads[fromIndex];
      selectedBeads[fromIndex] = selectedBeads[toIndex];
      selectedBeads[toIndex] = bead;
      selectedIndex = toIndex;
      layoutMotion = {
        fromByKey,
        startedAt: performance.now(),
        duration: 220
      };
    };

    const animateLayoutFromCurrentPositions = (duration = 260) => {
      const fromByKey = currentHitRegionMap();
      layoutMotion = {
        fromByKey,
        startedAt: performance.now(),
        duration
      };
    };

    const nearestSwapTargetIndex = (point) => {
      if (!dragState || selectedBeads.length < 2) return null;
      let nearest = null;

      hitRegions.forEach((region) => {
        if (region.index === dragState.dragIndex) return;
        const distance = Math.hypot(region.x - point.x, region.y - point.y);
        const threshold = Math.max(28, region.radius * 3.15);
        if (distance > threshold) return;
        if (!nearest || distance < nearest.distance) {
          nearest = { index: region.index, distance };
        }
      });

      return nearest ? nearest.index : null;
    };

    const isDragDeletePreview = (point) => {
      if (!dragState || selectedBeads.length === 0) return false;
      const layout = getBraceletLayout(point.size, selectedBeads);
      const dragRadius = layout.beadRadii[dragState.dragIndex] || layout.beadRadii[0] || 8;
      const centerPoint = { x: layout.center, y: layout.center };
      const startVector = { x: dragState.startX - layout.center, y: dragState.startY - layout.center };
      const currentVector = { x: point.x - layout.center, y: point.y - layout.center };
      const startDistance = Math.max(1, distanceBetween({ x: dragState.startX, y: dragState.startY }, centerPoint));
      const currentDistance = distanceBetween(point, centerPoint);
      const outwardDot = startVector.x * currentVector.x + startVector.y * currentVector.y;
      const deleteDistance = layout.braceletRadius + dragRadius * 3.2;

      return outwardDot > 0
        && currentDistance > startDistance + dragRadius * 1.3
        && currentDistance > deleteDistance;
    };

    const startCanvasDrag = (event, hit, point) => {
      selectedIndex = hit.index;
      beadMotion = null;
      dragState = {
        pointerId: event.pointerId,
        dragIndex: hit.index,
        startX: point.x,
        startY: point.y,
        currentX: point.x,
        currentY: point.y,
        previewTargetIndex: null,
        deletePreview: false,
        originalSnapshot: historySnapshot(),
        originalSignature: snapshotSignature(selectedBeads),
        hasMoved: false
      };
      lastMoveSoundTarget = hit.index;
      lastMoveSoundAt = 0;
      playSound('pick');
      root.classList.add('is-dragging-bead');
      window.getSelection()?.removeAllRanges();
      canvas.classList.add('is-dragging');
      canvas.setPointerCapture(event.pointerId);
      event.preventDefault();
      requestRender();
    };

    canvas.addEventListener('pointerdown', (event) => {
      const point = canvasPoint(event);
      const hit = hitRegionAtPoint(point);
      if (!hit) return;
      startCanvasDrag(event, hit, point);
    });

    if (hitLayer) {
      hitLayer.addEventListener('pointerdown', (event) => {
        const hitTarget = event.target.closest('[data-bead-index]');
        if (!hitTarget) return;
        const beadIndex = Number(hitTarget.dataset.beadIndex);
        const point = canvasPoint(event);
        const hit = hitRegions.find((region) => region.index === beadIndex) || hitRegionAtPoint(point);
        if (!hit) return;
        startCanvasDrag(event, hit, point);
      });
    }

    canvas.addEventListener('pointermove', (event) => {
      if (!dragState || dragState.pointerId !== event.pointerId) return;
      const point = canvasPoint(event);
      const distance = Math.hypot(point.x - dragState.startX, point.y - dragState.startY);
      if (distance < 6 && !dragState.hasMoved) return;

      dragState.hasMoved = true;
      dragState.currentX = point.x;
      dragState.currentY = point.y;
      dragState.deletePreview = isDragDeletePreview(point);
      dragState.previewTargetIndex = dragState.deletePreview ? null : nearestSwapTargetIndex(point);
      if (dragState.previewTargetIndex !== null && dragState.previewTargetIndex !== lastMoveSoundTarget) {
        const now = Date.now();
        if (now - lastMoveSoundAt > 80) {
          playSound('move');
          lastMoveSoundAt = now;
        }
        lastMoveSoundTarget = dragState.previewTargetIndex;
      }
      requestRender();
      event.preventDefault();
    });

    const finishCanvasDrag = (event) => {
      if (!dragState || dragState.pointerId !== event.pointerId) return;
      const originalSnapshot = dragState.originalSnapshot;
      const originalSignature = dragState.originalSignature;
      const shouldDelete = dragState.hasMoved && dragState.deletePreview;
      const shouldSwap = dragState.hasMoved
        && !shouldDelete
        && dragState.previewTargetIndex !== null
        && dragState.previewTargetIndex !== dragState.dragIndex
        && dragState.previewTargetIndex >= 0
        && dragState.previewTargetIndex < selectedBeads.length;
      const didMove = dragState.hasMoved;
      const fromIndex = dragState.dragIndex;
      const toIndex = dragState.previewTargetIndex;

      if (canvas.hasPointerCapture(event.pointerId)) {
        canvas.releasePointerCapture(event.pointerId);
      }

      dragState = null;
      root.classList.remove('is-dragging-bead');
      canvas.classList.remove('is-dragging');

      if (shouldDelete) {
        beadMotion = null;
        playSound('remove');
        animateLayoutFromCurrentPositions(260);
        selectedBeads.splice(fromIndex, 1);
        selectedIndex = Math.max(0, Math.min(fromIndex, selectedBeads.length - 1));
      } else if (shouldSwap) {
        swapBeads(fromIndex, toIndex);
        playSound('place');
      }
      suppressNextCanvasClick = didMove;

      const changed = snapshotSignature(selectedBeads) !== originalSignature;
      if (changed) {
        pushHistorySnapshot(originalSnapshot);
      }
      syncUi();
      event.preventDefault();
    };

    canvas.addEventListener('pointerup', finishCanvasDrag);
    canvas.addEventListener('pointercancel', finishCanvasDrag);

    canvas.addEventListener('click', (event) => {
      if (suppressNextCanvasClick) {
        suppressNextCanvasClick = false;
        return;
      }
      const point = canvasPoint(event);
      const hit = hitRegionAtPoint(point);
      if (!hit) return;
      selectedIndex = hit.index;
      syncUi();
    });

    categoriesEl.addEventListener('click', (event) => {
      const button = event.target.closest('[data-category]');
      if (!button) return;
      playSound('tap');
      statusOverride = '';
      activeCategory = button.dataset.category;
      renderCategories();
      renderGrid();
    });

    gridEl.addEventListener('click', (event) => {
      const card = event.target.closest('[data-bead-id]');
      if (!card) return;
      selectedLibraryId = card.dataset.beadId;
      addBead(resolvedBeadForDiameter(currentLibraryStyle()));
    });

    diameterGroup.addEventListener('click', (event) => {
      const button = event.target.closest('[data-diameter]');
      if (!button) return;
      playSound('tap');
      statusOverride = '';
      activeDiameter = Number(button.dataset.diameter);
      diameterGroup.querySelectorAll('[data-diameter]').forEach((diameterButton) => {
        diameterButton.classList.toggle('is-active', diameterButton === button);
      });
      syncUi();
    });

    removeButton.addEventListener('click', clearBracelet);
    undoButton.addEventListener('click', undo);
    submitButton.addEventListener('click', submitCart);
    soundToggleButton.addEventListener('click', toggleSound);
    designsOpenButton.addEventListener('click', () => {
      playSound('tap');
      openDesignsModal();
    });
    designsCloseButton.addEventListener('click', () => closeDesignsModal());
    designSaveButton.addEventListener('click', () => saveCurrentDesign(false));
    designCopyButton.addEventListener('click', () => saveCurrentDesign(true));
    designNewButton.addEventListener('click', requestNewDesign);
    designsList.addEventListener('click', (event) => {
      const deleteButton = event.target.closest('[data-delete-design-slot]');
      if (deleteButton) {
        deleteSavedDesign(deleteButton.dataset.deleteDesignSlot);
        return;
      }
      const loadButton = event.target.closest('[data-design-slot]');
      if (loadButton) requestDesignLoad(loadButton.dataset.designSlot);
    });
    designsModal.addEventListener('click', (event) => {
      if (event.target === designsModal) closeDesignsModal();
    });
    switchKeepButton.addEventListener('click', () => {
      closeSwitchModal(false);
      closeDesignsModal();
    });
    switchLoadButton.addEventListener('click', () => {
      if (pendingDesignSlot === 'new') startNewDesign();
      else if (pendingDesignSlot !== null) loadSavedDesign(pendingDesignSlot);
    });
    sizeGuideOpenButton.addEventListener('click', openSizeGuide);
    sizeGuideCloseButton.addEventListener('click', closeSizeGuide);
    sizeGuideTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        selectSizeGuideTab(tab.dataset.stoneBuilderSizeGuideTab, true);
      });
      tab.addEventListener('keydown', handleSizeGuideTabKeydown);
    });
    sizeGuideModal.addEventListener('click', (event) => {
      if (event.target === sizeGuideModal) closeSizeGuide();
    });
    modalCloseButton.addEventListener('click', hideMinimumModal);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) hideMinimumModal();
    });
    root.addEventListener('keydown', (event) => {
      if (!switchModal.hidden) trapFocus(switchModal, event);
      else if (!designsModal.hidden) trapFocus(designsDialog, event);
      trapSizeGuideFocus(event);
      if (event.key === 'Escape' && !switchModal.hidden) {
        closeSwitchModal();
        return;
      }
      if (event.key === 'Escape' && !designsModal.hidden) {
        closeDesignsModal();
        return;
      }
      if (event.key === 'Escape' && !sizeGuideModal.hidden) {
        closeSizeGuide();
        return;
      }
      if (event.key === 'Escape' && !modal.hidden) hideMinimumModal();
    });
    window.addEventListener('resize', () => {
      updateGridRows();
      requestRender();
    });

    if ('ResizeObserver' in window) {
      const gridResizeObserver = new ResizeObserver(updateGridRows);
      gridResizeObserver.observe(gridEl);
    }

    soundEnabled = readSoundPreference();
    updateSoundToggle();
    readSavedDesignState();
    let restoredDraftUnavailableCount = 0;
    if (savedDraft && savedDraft.beads.length) {
      const restoredDraft = resolveStoredBeads(savedDraft.beads);
      selectedBeads = restoredDraft.beads;
      restoredDraftUnavailableCount = restoredDraft.unavailableCount;
      const sourceDesign = findSavedDesign(savedDraft.sourceSlot);
      activeDesignSlot = sourceDesign ? sourceDesign.slot : null;
      if (sourceDesign) {
        activeDesignSignature = designSignature(resolveStoredBeads(sourceDesign.beads).beads);
      }
      lastPersistedDraftSignature = `${activeDesignSlot || 0}:${designSignature()}`;
    }

    renderDiameterButtons();
    syncUi();
    if (selectedBeads.length) {
      showTemporaryStatus(restoredDraftUnavailableCount ? 'Some beads are unavailable.' : 'Draft restored.');
    }
  };

  const initAllStoneBuilders = () => {
    document.querySelectorAll('[data-stone-builder-root]').forEach(initStoneBuilder);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStoneBuilders);
  } else {
    initAllStoneBuilders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches('[data-stone-builder-root]')
      ? event.target
      : event.target.querySelector('[data-stone-builder-root]');
    if (root) initStoneBuilder(root);
  });
  })();
